<div class="error">
    <h1>403 - Forbidden</h1>
    <mat-icon>desktop_access_disabled</mat-icon>
    <p>You do not have permission to access this page.</p>
    <a routerLink="/">Go back to Home</a>
</div>